// Prepinac vzhladu portalu: "v1" = povodny Limitless vzhlad, "v2" = redesign (public/assets/css/offeris-v2.css).
// Vsetky styly v2 su pod triedou .theme-v2 na <html>, takze v1 vyzera presne ako predtym.
// Prepnutie: ?theme=v1 alebo ?theme=v2 v URL (ulozi sa do localStorage), inak DEFAULT_THEME.

// web aj PWA štartujú v redesigne (v2), Cordova appka zatiaľ v pôvodnom vzhľade (v1)
export const DEFAULT_THEME = window.cordova ? "v1" : "v2";
const STORAGE_KEY = "offeris_theme";
const THEMES = ["v1", "v2"];

function readStoredTheme() {
    try {
        return window.localStorage.getItem(STORAGE_KEY);
    } catch (e) {
        return null;
    }
}

function storeTheme(theme) {
    try {
        window.localStorage.setItem(STORAGE_KEY, theme);
    } catch (e) {
        // localStorage nemusi byt dostupny (privatne okno), tema sa len neulozi
    }
}

function readUrlTheme() {
    // BrowserRouter ma parameter v search, HashRouter (Cordova) za # v hash
    let match = (window.location.search + window.location.hash).match(/[?&]theme=(v\d)/);
    return match ? match[1] : null;
}

export function getTheme() {
    let urlTheme = readUrlTheme();
    if (THEMES.includes(urlTheme)) {
        storeTheme(urlTheme);
        return urlTheme;
    }
    let stored = readStoredTheme();
    return THEMES.includes(stored) ? stored : DEFAULT_THEME;
}

export function initTheme() {
    let theme = getTheme();
    let root = document.documentElement;
    THEMES.forEach((t) => root.classList.remove("theme-" + t));
    root.classList.add("theme-" + theme);
    return theme;
}
